export function scopeCmsHtml(html, prefix = '.cms-page') {
  const styleBlocks = [];

  const bodyHtml = html.replace(
    /<style[^>]*>([\s\S]*?)<\/style>/gi,
    (_, css) => {
      styleBlocks.push(prefixCss(css, prefix));
      return '';
    }
  );

  return {
    scopedStyles: styleBlocks.join('\n'),
    bodyHtml: bodyHtml.trim(),
  };
}

/**
 * Prefixes CSS selectors using a flat regex scan (not a CSS parser).
 * Works for typical CMS-authored CSS. Edge cases like selectors mixed with
 * keyframe stops in a single rule are not supported.
 * Note: bodyHtml is trimmed of leading/trailing whitespace.
 */
function prefixCss(css, prefix) {
  return css.replace(/([^{}]+)\{/g, (match, rawSelector) => {
    const selector = rawSelector.trim();
    if (
      !selector ||
      selector.startsWith('@') ||
      selector.split(',').every(s => /^(from|to|\d+%)$/.test(s.trim()))
    ) {
      return match;
    }
    const prefixed = selector
      .split(',')
      .map(s => `${prefix} ${s.trim()}`)
      .join(', ');
    return `${prefixed} {`;
  });
}
